import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getFullName } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text';
import { Button, Checkbox } from 'antd';
import { LockOutlined, MailOutlined, UnlockOutlined } from '@ant-design/icons';
export function getUserNameColumn(currentUserId) {
    return {
        key: 'name',
        render: (_, user) => {
            const fullName = getFullName(user.firstName, user.lastName);
            return currentUserId === user.id ? `${fullName} (You)` : fullName;
        },
        title: COPY_SPECIFIC.NAME,
        width: '20%'
    };
}
export const userEmailColumn = {
    dataIndex: 'email',
    key: 'email',
    title: COPY_SPECIFIC.EMAIL,
    width: '200px'
};
export function getUserReadOnlyColumn(currentUserId, disabled, clickHandler) {
    return {
        className: 'center-align-cell',
        dataIndex: 'isReadOnly',
        key: 'isReadOnly',
        render: (_, user) => {
            const { id, isReadOnly } = user;
            return (React.createElement(Checkbox, { checked: isReadOnly, disabled: disabled || currentUserId === id, onChange: () => clickHandler(user) }));
        },
        title: COPY_SPECIFIC.READ_ONLY,
        width: '70px'
    };
}
export function getUserStatusColumn(currentUserId, disabled, inviteClickHandler, lockToggleHandler) {
    return {
        className: 'center-align-cell',
        key: 'status',
        render: (_, user) => {
            const { id, isInvited, isLocked } = user;
            if (currentUserId === id) {
                return null;
            }
            if (isLocked) {
                return (React.createElement(Button, { disabled: disabled, icon: React.createElement(LockOutlined, null), onClick: () => lockToggleHandler(user.id, false) }, COPY_SPECIFIC.UNLOCK_USER));
            }
            if (isInvited) {
                return (React.createElement(Button, { disabled: disabled, icon: React.createElement(MailOutlined, null), onClick: () => inviteClickHandler(user) }, COPY_SPECIFIC.RESEND_INVITE));
            }
            if (!isLocked) {
                return (React.createElement(Button, { disabled: disabled, icon: React.createElement(UnlockOutlined, null), onClick: () => lockToggleHandler(user.id, true) }, COPY_SPECIFIC.LOCK_USER));
            }
            return null;
        },
        width: '115px'
    };
}
export function getUserOwnerCountColumn(disabled) {
    return {
        align: 'right',
        dataIndex: 'ownerCount',
        key: 'ownerCount',
        render: (_, user) => { var _a; return React.createElement(SonarText, { disabled: disabled }, (_a = user.ownerCount) === null || _a === void 0 ? void 0 : _a.toLocaleString()); },
        title: COPY_SPECIFIC.ENTITY_OWNER,
        width: '120px'
    };
}
export function getUserStakeholderCountColumn(disabled) {
    return {
        align: 'right',
        dataIndex: 'stakeholderCount',
        key: 'stakeholderCount',
        render: (_, user) => { var _a; return React.createElement(SonarText, { disabled: disabled }, (_a = user.stakeholderCount) === null || _a === void 0 ? void 0 : _a.toLocaleString()); },
        title: COPY_SPECIFIC.ENTITY_STAKEHOLDER,
        width: '120px'
    };
}
